import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "authentication-heading w-100 d-flex justify-content-around" }
const _hoisted_2 = { class: "h1 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_4 = { class: "authentication-buttons-spacer d-flex flex-column" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-outline-light w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonElement = _resolveComponent("ButtonElement")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('login.heading')), 1)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "d-flex flex-column login-form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submitLogin()), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "email",
        placeholder: "E-mail",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.data.email) = $event))
      }, null, 512), [
        [_vModelText, _ctx.request.data.email]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Password",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ButtonElement, {
          theme: "primary",
          type: "submit",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('login.buttons.login')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_router_link, { to: { name: 'authentication.forgot-password' } }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('login.buttons.forgot_password')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 32)
  ], 64))
}